import React, {useMemo} from 'react'
import DropDown from '../dropdown';
import {CustomerGroups} from '../../../api/services/next'

const CustomerGroupDropDown = ({...rest}) => {	
    const spec = useMemo(() => ({
		IsActive: true,
	}), []);
	
    return (
        <DropDown
            search
            api={CustomerGroups.GetCustomerGroups}
            spec={spec}
            textField="Name"
            valueField="Id" 
            {...rest}
        />
    );
}

export default CustomerGroupDropDown

